<template>
  <div class="mb-3 col-12">
    <b-row
      v-if="itemsFiltrados && itemsFiltrados.length > 0"
      class="mb-1 align-items-end"
    >
      <b-col md="4">
        <label>Diagnóstico 1 (masivo)</label>
        <v-select
          :options="opcionesDiagnosticos"
          v-model="bulkData.diagnostico_1"
          placeholder="Seleccione o escriba"
          label="text"
          @search="onSearchDiagnosticos"
          :loading="searchDiagnosticos.loading"
          clearable
        >
          <template #no-options>
            {{ noDiagnosticosMessage() }}
          </template>
        </v-select>
      </b-col>

      <b-col md="4">
        <label>Diagnóstico 2 (masivo)</label>
        <v-select
          :options="opcionesDiagnosticos"
          v-model="bulkData.diagnostico_2"
          placeholder="Seleccione o escriba"
          label="text"
          @search="onSearchDiagnosticos"
          :loading="searchDiagnosticos.loading"
          clearable
        >
          <template #no-options>
            {{ noDiagnosticosMessage() }}
          </template>
        </v-select>
      </b-col>

      <b-col md="4">
        <label>Procedimiento tarifario (masivo)</label>
        <v-select
          :options="opcionesProcedimientos"
          v-model="bulkData.procedimiento_cie"
          placeholder="Seleccione o escriba"
          label="text"
          @search="onSearchProcedimientos"
          :loading="searchProcedimientos.loading"
          clearable
        />
      </b-col>

      <b-col cols="12" class="mt-1 d-flex justify-content-between align-items-center">
        <small class="text-muted">
          Seleccionados: {{ selectedTokens.length }} | Editables: {{ selectableTokenList.length }}
        </small>
        <button
          class="btn btn-sm btn-primary"
          @click="aplicarMasivoSeleccionados"
        >
          Aplicar a seleccionados
        </button>
      </b-col>
    </b-row>

    <b-table
      v-if="itemsFiltrados && itemsFiltrados.length > 0"
      striped
      small
      :items="itemsFiltrados"
      :fields="fieldsTable"
    >
      <template #head(select_row)>
        <input
          type="checkbox"
          :checked="isAllSelectableChecked"
          @change="toggleSelectAll($event.target.checked)"
          :disabled="selectableTokenList.length === 0"
        />
      </template>

      <template #cell(select_row)="data">
        <input
          v-if="isRowSelectable(data.item)"
          type="checkbox"
          :checked="selectedTokens.includes(data.item.token)"
          @change="toggleRowSelection(data.item, $event.target.checked)"
        />
      </template>

      <template #cell(realizado)="data">
        <div v-if="!data.item.encontrado">
          <input
          type="checkbox"
           :checked="data.item.realizado || data.item.fecha_realizacion"
  @change="toogleRealizado(data.item, $event.target.checked)"

          >
        </input>
        </div>
      </template>

      <template #cell(fecha_realizacion)="data">
        <div v-if="!data.item.encontrado">
          {{ formatFecha(data.item.fecha_realizacion) }}
        </div>
      </template>

      <template #cell(lado)="data">
        {{ namePieza(data.item.procedimiento, data.item.lado, data.item.number) }}
      </template>
       <template #cell(movimiento)="data">
          <div v-if="!data.item.encontrado">
  <v-select
  v-model="data.item.movimiento"
  :options="[1, 2, 3]"
  label="Seleccione"
  dense
  outlined
  @update:model-value="actualizarCampo(data.item, 'movimiento', $event)"
></v-select>
  </div>
  <div v-else>
    {{ data.item.movimiento || '-' }}
  </div>
      </template>
      <!-- Diagnóstico 1 -->
      <template #cell(diagnostico_1)="data">
        <div v-if="!data.item.encontrado">
          <v-select
            :options="opcionesDiagnosticos"
            v-model="data.item.diagnostico_1"
            placeholder="Seleccione o escriba"
            label="text"
            @search="onSearchDiagnosticos"
            :loading="searchDiagnosticos.loading"
            clearable
            @input="actualizarDiagnostico(data.item, 'diagnostico_1', $event)"
            
          >
            <template #no-options>
              {{ noDiagnosticosMessage() }}
            </template>
          </v-select>
        </div>
      </template>

      <!-- Diagnóstico 2 -->
      <template #cell(diagnostico_2)="data">
        <div v-if="!data.item.encontrado">
          <v-select
            
            :options="opcionesDiagnosticos"
            v-model="data.item.diagnostico_2"
            placeholder="Seleccione o escriba"
            label="text"
            @search="onSearchDiagnosticos"
            :loading="searchDiagnosticos.loading"
            clearable
            @input="actualizarDiagnostico(data.item, 'diagnostico_2', $event)"
          >
            <template #no-options>
              {{ noDiagnosticosMessage() }}
            </template>
          </v-select>
        </div>
      </template>
      <!-- Procedimiento -->
      <template #cell(procedimiento)="data">
        <div>
          {{ getProcedimientoText(data.item.procedimiento) }}
        </div>
      </template>
      <!-- Procedimiento -->
      <template #cell(procedimiento_cie)="data">
        <div v-if="!data.item.encontrado">
          <v-select
            
            :options="opcionesProcedimientos"
            v-model="data.item.procedimiento_cie"
            placeholder="Seleccione o escriba"
            label="text"
            @search="onSearchProcedimientos"
            :loading="searchProcedimientos.loading"
            clearable
            @input="
              actualizarProcedimiento(data.item, 'procedimiento_cie', $event)
            "
          >
            <!-- <template #no-options>
            {{ noDiagnosticosMessage() }}
          </template> -->
          </v-select>
        </div>
      </template>

      <!-- Doctor -->
      <template #cell(doctor)="data">
        <div v-if="!data.item.encontrado">
          <v-select
            v-if="!userDoctor && !data.item.doctor"
            :options="opcionesDoctor"
            v-model="data.item.doctor"
            placeholder="Seleccione o escriba"
            label="text"
            @search="onSearchDoctor"
            :loading="searchDoctor.loading"
            clearable
            @input="actualizarDoctor(data.item, 'doctor', $event)"
          >
            <!-- <template #no-options>
            {{ noDiagnosticosMessage() }}
          </template> -->
          </v-select>
          <div v-else>
            <label>{{ doctorExists(data.item) }}</label>
          </div>
        </div>
      </template>

      <template #cell(acciones)="data">
        <button
          v-if="puedeEliminar(data.item.token)"
          class="btn btn-sm btn-danger"
          @click="eliminarItem(data.item.token)"          
          title="Eliminar fila"
        >
          <i class="fa-solid fa-trash"></i>
        </button>
         <!-- <button
          v-if="puedeEliminar"
          class="btn btn-sm btn-danger"
          @click="eliminarItem(data.item.token)"
          :disabled="data.item.original"
          title="Eliminar fila"
        >
          <i class="fa-solid fa-trash"></i>
        </button> -->

        <!-- <button
    class="btn btn-sm btn-danger"
    @click="enviarImagen(data.item)"
    
    title="Enviar Imagen"
  >
    <i class="fa-solid fa-trash"></i>
  </button> -->
      </template>
    </b-table>
  </div>
</template>

<script>
import { BTable } from "bootstrap-vue";
import { comprobarRoles } from "../../../../shared/helpers";
import { ROLES } from "../../../../shared/constants";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { diagnosticosService } from "../../../atencionMedica/services";
import { odontoServices } from "../../../odontologia/services/odontoServices";
import { getEstablecimientoLS, getInfoDoc } from "../../../../shared/helpers";
import { doctoresService } from "../../../administracion/services";
import Swal from "sweetalert2"; // Asegúrate de tener esta importación


export default {
  name: "TableOdontograma",
  components: {
    BTable,
    vSelect,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
      required: false,
    },
    newProcessCanDelete: {
       type: Array,
      default: () => [],
      required: false,
    },
    citaPosterior: {
      required: false,
      default: false,
    },
  },

  async created() {
    const doctorSession = await this.getDataDoc();
    console.log(doctorSession);

    if (doctorSession) {
      this.userDoctor = true;
    }
  },

  data() {
    return {
      canEditar: true,
      optionsProcedimiento: [
        { text: "Caries en la zona", value: "caz", disabled: false },
        { text: "Caries en toda la pieza", value: "cap", disabled: false },
        { text: "Extraer/Extraida", value: "ext", disabled: false },
        { text: "Corona en pieza", value: "cop", disabled: false },
        { text: "Sellante", value: "sellante", disabled: false },
        { text: "Endodoncia", value: "end", disabled: false },
        { text: "Cavidad encontrada", value: "enc", disabled: false },
        { text: "Cuello base cavitaria", value: "cuello", disabled: false },
        { text: "Restauración", value: "restauracion", disabled: false },
        { text: "Incrustación", value: "incrustacion", disabled: false },
        { text: "Retratamiento", value: "retratamiento", disabled: false },
        { text: "Recromía", value: "recromia", disabled: false },
        { text: "Carilla", value: "carilla", disabled: false },
        {
          text: "Alargamiento corona",
          value: "alargamiento_corona",
          disabled: false,
        },
        { text: "Profilaxis", value: "profilaxis", disabled: false },
        {
          text: "Aplicación de flúor en gel",
          value: "aplicacion_fluor_gel",
          disabled: false,
        },
        {
          text: "Aplicación de flúor barniz",
          value: "aplicacion_fluor_barniz",
          disabled: false,
        },
        { text: "Microabrasión", value: "microabrasion", disabled: false },
        { text: "Sensibilidad", value: "sensibilidad", disabled: false },
        { text: "Retracción", value: "retraccion", disabled: false },
        { text: "Cirugía", value: "cirugia", disabled: false },
        {
          text: "Movilidad dental",
          value: "movilidad_dental",
          disabled: false,
        },
        { text: "Furca", value: "furca", disabled: false },
        { text: "Odontosección", value: "odontoseccion", disabled: false },
        {
          text: "Restos radiculares",
          value: "restos_radiculares",
          disabled: false,
        },
        {
          text: "Prótesis removible",
          value: "protesis_removible",
          disabled: false,
        },
        { text: "Prótesis total", value: "protesis_total", disabled: false },
        { text: "Puente", value: "puente", disabled: false },
        { text: "Perno", value: "perno", disabled: false },
        { text: "Periodoncia", value: "periodoncia", disabled: false },
        { text: "Odontoma", value: "odontoma", disabled: false },
        { text: "Quiste", value: "quiste", disabled: false },
        { text: "Blanqueamiento", value: "blanqueamiento", disabled: false },
        { text: "Férula", value: "ferula", disabled: false },
        {
          text: "Placa miorelajante",
          value: "placa_miorelajante",
          disabled: false,
        },
        {
          text: "Control ortodoncia",
          value: "control_ortodoncia",
          disabled: false,
        },
        { text: "Sin espacio", value: "sin_espacio", disabled: false },
        { text: "Supernumerario", value: "supernumerario", disabled: false },
      ],

      userDoctor: false,
      isLoading: false,

      searchDiagnosticos: {
        query: "",
        isLoading: false,
        searchFailed: false,
        selected: null,
      },

      searchProcedimientos: {
        query: "",
        isLoading: false,
        searchFailed: false,
        selected: null,
      },
      procedimientosSinDisabled: [
        "profilaxis",
        "cirugia",
        "blanqueamiento",
        "control_ortodoncia",
      ],

      searchDoctor: {
        query: "",
        isLoading: false,
        searchFailed: false,
        selected: null,
      },
      itemsFiltrados: [],
      selectedTokens: [],
      bulkData: {
        diagnostico_1: null,
        diagnostico_2: null,
        procedimiento_cie: null,
      },

      // Campos de la tabla
      fieldsTable: [
        {
          key: "select_row",
          label: "",
          thStyle: "width: 36px; min-width: 36px;",
          tdClass: "text-center",
        },
        {
          key: "number",
          label: "# Pieza",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        { key: "lado", label: "Lado", sortable: true },

        // ✅ Fijar ancho en campos de diagnóstico
        {
          key: "diagnostico_1",
          label: "Diagnóstico 1",
          sortable: true,
          thStyle: "width: 220px; min-width: 220px;",
          tdStyle: "width: 220px; min-width: 220px;",
        },
        {
          key: "diagnostico_2",
          label: "Diagnóstico 2",
          sortable: true,
          thStyle: "width: 220px; min-width: 220px;",
          tdStyle: "width: 220px; min-width: 220px;",
        },
           {
          key: "movimiento",
          label: "M",
          sortable: true,
          thStyle: "width: 80px; min-width: 80px;",
          tdStyle: "width: 80px; min-width: 80px;",
        },

        // ✅ Las siguientes columnas son completamente responsive
        { key: "procedimiento", label: "Procedimiento", sortable: true },
        {
          key: "procedimiento_cie",
          label: "Procedimiento Tarifario",
          sortable: true,
          thStyle: "width: 220px; min-width: 220px;",
          tdStyle: "width: 220px; min-width: 220px;",
        },
        { key: "doctor", label: "Medico", sortable: true },
        { key: "realizado", label: "realizado", sortable: true },
        {
          key: "fecha_realizacion",
          label: "Fecha realización",
          sortable: true,
        },
        {
          key: "acciones",
          label: "acciones",
          thStyle: "width: 40px; min-width: 40px;",
          tdClass: "text-center",
        },
      ],

      // Lista de diagnósticos disponibles
      opcionesDiagnosticos: [],
      opcionesProcedimientos: [],
      opcionesDoctor: [],
    };
  },
  computed: {
    isJefeMedico() {
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.JEFE_VALIDACIONES]);
    },
    fechaCita() {
      return this.$store.state?.atencionCita?.dataCita?.fechaCita || null;
    },
    horaCita() {
      return this.$store.state?.atencionCita?.dataCita?.horaCita || null;
    },
    selectableTokenList() {
      return this.itemsFiltrados
        .filter((item) => this.isRowSelectable(item) && !!item.token)
        .map((item) => item.token);
    },
    isAllSelectableChecked() {
      if (!this.selectableTokenList.length) return false;
      return this.selectableTokenList.every((token) =>
        this.selectedTokens.includes(token)
      );
    },
  },

  methods: {
    normalizeSelectOption(rawOption) {
      if (rawOption == null) return null;

      if (typeof rawOption !== "object") {
        return {
          text: String(rawOption),
          value: rawOption,
        };
      }

      const value =
        rawOption.value ??
        rawOption.id ??
        rawOption.procedimientoId ??
        rawOption.procOdontoId ??
        rawOption.codigo ??
        rawOption.cod ??
        null;

      const textBase =
        rawOption.text ??
        rawOption.label ??
        rawOption.descripcion ??
        rawOption.nombre ??
        rawOption.detalle ??
        null;

      const text =
        textBase ??
        (rawOption.codigo && rawOption.descripcion
          ? `[${rawOption.codigo}] ${rawOption.descripcion}`
          : null) ??
        (value != null ? String(value) : "");

      return {
        ...rawOption,
        text,
        value: value ?? text,
      };
    },

    puedeEliminar(token){
      if(this.citaPosterior && this.isJefeMedico ){
        return true
      }else if(!this.citaPosterior){
        return true
      }else if(this.newProcessCanDelete.find(item => item === token)){
        return true
      }
      else{
        return false
      }
    },

    actualizarCampo(item, campo, valor) {
  item[campo] = valor;
  this.emitirDatos();
},
    isRowSelectable(item) {
      return !!item?.token && !item?.encontrado;
    },
    toggleRowSelection(item, checked) {
      if (!this.isRowSelectable(item)) return;

      if (checked) {
        if (!this.selectedTokens.includes(item.token)) {
          this.selectedTokens = [...this.selectedTokens, item.token];
        }
        return;
      }

      this.selectedTokens = this.selectedTokens.filter(
        (token) => token !== item.token
      );
    },
    toggleSelectAll(checked) {
      if (!checked) {
        this.selectedTokens = [];
        return;
      }
      this.selectedTokens = [...this.selectableTokenList];
    },
    async aplicarMasivoSeleccionados() {
      if (this.selectedTokens.length === 0) {
        await Swal.fire({
          icon: "warning",
          title: "Sin selección",
          text: "Seleccione al menos un registro para aplicar en grupo.",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      const { diagnostico_1, diagnostico_2, procedimiento_cie } = this.bulkData;
      const hasDataToApply =
        diagnostico_1 !== null ||
        diagnostico_2 !== null ||
        procedimiento_cie !== null;

      if (!hasDataToApply) {
        await Swal.fire({
          icon: "warning",
          title: "Datos incompletos",
          text: "Ingrese al menos un dato masivo (diagnóstico o procedimiento tarifario).",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      this.itemsFiltrados = this.itemsFiltrados.map((item) => {
        if (!this.selectedTokens.includes(item.token)) return item;
        if (!this.isRowSelectable(item)) return item;

        return {
          ...item,
          diagnostico_1: diagnostico_1 ?? item.diagnostico_1,
          diagnostico_2: diagnostico_2 ?? item.diagnostico_2,
          procedimiento_cie: procedimiento_cie ?? item.procedimiento_cie,
        };
      });

      this.emitirDatos();
    },
    isProcedimientoEditable(item) {
      return (
        this.canEditar ||
        this.procedimientosSinDisabled.includes(item.procedimiento)
      );
    },

    getDataDoc() {
      const dataDoc = getInfoDoc();
      return dataDoc;
    },
    doctorExists(item) {
      let doc_data = item?.doctor || "";
      if (!doc_data) {
        const dataDoc = this.getDataDoc();
        doc_data = `${dataDoc.primerApellido} ${dataDoc.primerNombre}`;
      }

      return doc_data;
    },
   namePieza(value, lado, number) {
  // Solo aplicar la lógica si el procedimiento es 'caz' o 'enc'
  if (value !== "caz" && value !== "enc" && value !== "ext" && lado !== "cuello") return "-";

  const num = parseInt(number);

  if (isNaN(num)) return "-";

  // Definimos las reglas para cada cuadrante
  const reglas = [
    {
      rango: [18, 11], // Cuadrante 1 (superior derecha)
      zonas: {
        izquierda: "distal",
        derecha: "mesial",
        arriba: "vestibular",
        abajo: "palatina",
        centro: "oclusal",
        cuello: "cuello",
      },
    },
        {
      rango: [55, 51], // Cuadrante 1 (superior derecha)
      zonas: {
        izquierda: "distal",
        derecha: "mesial",
        arriba: "vestibular",
        abajo: "palatina",
        centro: "oclusal",
        cuello: "cuello",
      },
    },
    {
      rango: [21, 28], // Cuadrante 2 (superior izquierda)
      zonas: {
        izquierda: "mesial",
        derecha: "distal",
        arriba: "vestibular",
        abajo: "palatina",
        centro: "oclusal",
        cuello: "cuello",
      },
    },
     {
      rango: [61, 65], // Cuadrante 2 (superior izquierda)
      zonas: {
        izquierda: "mesial",
        derecha: "distal",
        arriba: "vestibular",
        abajo: "palatina",
        centro: "oclusal",
        cuello: "cuello",
      },
    },
    {
      rango: [48, 41], // Cuadrante 4 (inferior derecha)
      zonas: {
        izquierda: "distal",
        derecha: "mesial",
        arriba: "lingual",
        abajo: "vestibular",
        centro: "oclusal",
        cuello: "cuello",
      },
    },
        {
      rango: [85, 81], // Cuadrante 4 (inferior derecha)
      zonas: {
        izquierda: "distal",
        derecha: "mesial",
        arriba: "lingual",
        abajo: "vestibular",
        centro: "oclusal",
        cuello: "cuello",
      },
    },
    {
      rango: [31, 38], // Cuadrante 3 (inferior izquierda)
      zonas: {
        izquierda: "mesial",
        derecha: "distal",
        arriba: "lingual",
        abajo: "vestibular",
        centro: "oclusal",
        cuello: "cuello",
      },
    },
     {
      rango: [71, 75], // Cuadrante 3 (inferior izquierda)
      zonas: {
        izquierda: "mesial",
        derecha: "distal",
        arriba: "lingual",
        abajo: "vestibular",
        centro: "oclusal",
        cuello: "cuello",
      },
    },
  ];

  for (const regla of reglas) {
    const [inicio, fin] = regla.rango;

    const enRango = inicio < fin
      ? num >= inicio && num <= fin
      : num <= inicio && num >= fin;

    if (enRango) {
      return regla.zonas[lado] || "-";
    }
  }

  return "-"; // Si no está en ningún rango válido
},

    eliminarItem(token) {
      this.$store.commit("removeZonaProcedimientoByToken", token);
    },

    actualizarDiagnostico(item, campo, valor) {
      // Actualiza el valor en itemsFiltrados
      item[campo] = valor;

      // Emitimos para que el padre sepa que hubo un cambio y pueda actualizar su array original
      this.emitirDatos();
    },
    actualizarDoctor(item, campo, valor) {
      // Actualiza el valor en itemsFiltrados
      item[campo] = valor?.text;

      // Emitimos para que el padre sepa que hubo un cambio y pueda actualizar su array original
      this.emitirDatos();
    },
    actualizarProcedimiento(item, campo, valor) {
      // Actualiza el valor en itemsFiltrados
      item[campo] = valor;

      // Emitimos para que el padre sepa que hubo un cambio y pueda actualizar su array original
      this.emitirDatos();
    },

    emitirDatos() {
      this.$emit("update-items", this.itemsFiltrados);
    },
    formatFecha(fecha) {
      if (!fecha) return "";
      const d = new Date(fecha);
      const pad = (n) => n.toString().padStart(2, "0");

      const dd = pad(d.getDate());
      const mm = pad(d.getMonth() + 1);
      const YY = d.getFullYear().toString().slice(-2);
      const HH = pad(d.getHours());
      const MM = pad(d.getMinutes());

      return `${dd}--${mm}--${YY}-${HH}::${MM}`;
    },

  async toogleRealizado(item, isChecked) {
  if (isChecked) {
    const tieneDiagnostico =
      item.diagnostico_1 !== null || item.diagnostico_2 !== null;
    const tieneProcedimientoCIE = item.procedimiento_cie !== null;

    if (!tieneDiagnostico || !tieneProcedimientoCIE) {
      await Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Debe agregar al menos un diagnóstico y un procedimiento CIE antes de marcar como realizado.",
        confirmButtonText: "Aceptar",
      });

      // NO actualizar el valor en este caso
      return;
    }

    if (!item.doctor) {
      if (this.userDoctor) {
        const dataDoc = this.getDataDoc();
        item.doctor = `${dataDoc.primerApellido} ${dataDoc.primerNombre}`;
      } else {
        await Swal.fire({
          icon: "info",
          title: "Seleccione un médico",
          text: "Debe seleccionar un médico antes de marcar como realizado.",
          confirmButtonText: "Aceptar",
        });

        return;
      }
    }

    const fechaActual = this.obtenerFechaRealizacion();
    item.realizado = true;
    item.fecha_realizacion = fechaActual;

    this.$store.commit("updateRealizadoByToken", {
      token: item.token,
      encontrado: false,
      realizado: true,
      fecha: fechaActual,
      doctor: item.doctor,
    });
  } else {
    item.realizado = false;
    item.fecha_realizacion = null;

    this.$store.commit("updateRealizadoByToken", {
      token: item.token,
      realizado: false,
      encontrado: false,
      fecha: null,
      doctor: item.doctor,
    });
  }

  this.emitirDatos();
},

    obtenerFechaRealizacion() {
      if (!this.fechaCita) return new Date().toISOString();

      const hora = this.horaCita || "00:00:00";
      const fechaCompleta = new Date(`${this.fechaCita}T${hora}`);

      return isNaN(fechaCompleta) ? new Date().toISOString() : fechaCompleta.toISOString();
    },

    getProcedimientoText(value) {
      if (!value) return ""; // o algún texto por defecto

      const found = this.optionsProcedimiento.find(
        (opt) => opt.value === value
      );
      return found ? found.text : value; // si no encuentra, muestra el valor crudo
    },
    noDiagnosticosMessage() {
      if (this.searchDiagnosticos.query.length <= 3)
        return "Escribe más caracteres para buscar...";

      if (this.searchDiagnosticos.isLoading) return "Buscando diagnosticos...";

      if (this.searchDiagnosticos.searchFailed)
        return "Error al buscar diagnosticos. Intente de nuevo.";

      if (this.opcionesDiagnosticos.length === 0 && !this.isLoading)
        return "No se encontraron diagnosticos que coincidan con tu búsqueda";

      return "Escribe para buscar diagnosticos...";
    },
    async filterDiagnosticos(query) {
      const diagnosticos = await diagnosticosService.getByQuerySelect(query);

      // Truncar el texto a max 30 caracteres y añadir "..." si es más largo
      const diagnosticosTruncados = diagnosticos.map((d) => {
        const maxLength = 20;
        let truncatedText = d.text;
        if (truncatedText.length > maxLength) {
          truncatedText = truncatedText.slice(0, maxLength) + "...";
        }
        return {
          ...d,
          text: truncatedText,
        };
      });

      return diagnosticosTruncados;
    },
    async filterProcedimientos(query) {
      const establecimiento = getEstablecimientoLS()?.id;
      const odonto = await odontoServices.searchByTerm(query, establecimiento);

      // Truncar el texto a max 30 caracteres y añadir "..." si es más largo
      const services = odonto.map((d) => {
        const maxLength = 20;
        let truncatedText = d.text;
        if (truncatedText.length > maxLength) {
          truncatedText = truncatedText.slice(0, maxLength) + "...";
        }
        return {
          ...d,
          text: truncatedText,
        };
      });

      return services;
    },

    async filterDoctores(query) {
      const establecimiento = getEstablecimientoLS()?.id;
      const doctorResponse = await doctoresService.searchDoctoresByTermSelect(
        query,
        establecimiento
      );

      // Truncar el texto a max 30 caracteres y añadir "..." si es más largo
      const doctores = doctorResponse.map((d) => {
        const maxLength = 20;
        let truncatedText = d.text;
        if (truncatedText.length > maxLength) {
          truncatedText = truncatedText.slice(0, maxLength) + "...";
        }
        return {
          ...d,
          //text: truncatedText
        };
      });

      return doctores;
    },

    async onSearchDiagnosticos(query) {
      this.searchDiagnosticos.query = query;

      if (query.length < 4) {
        this.opcionesDiagnosticos = [];
        return;
      }

      this.searchDiagnosticos.isLoading = true;
      this.opcionesDiagnosticos = [];
      this.opcionesDiagnosticos = await this.filterDiagnosticos(query);
      this.searchDiagnosticos.isLoading = false;
    },

    async onSearchProcedimientos(query) {
      this.searchProcedimientos.query = query;

      if (query.length < 4) {
        this.opcionesProcedimientos = [];
        return;
      }

      this.searchProcedimientos.isLoading = true;
      this.opcionesProcedimientos = [];
      this.opcionesProcedimientos = await this.filterProcedimientos(query);
      this.searchProcedimientos.isLoading = false;
    },

    async onSearchDoctor(query) {
      this.searchDoctor.query = query;

      if (query.length < 2) {
        this.opcionesDoctor = [];
        return;
      }

      this.searchDoctor.isLoading = true;
      this.opcionesDoctor = [];
      this.opcionesDoctor = await this.filterDoctores(query);
      this.searchDoctor.isLoading = false;
    },

    emitirDatos() {
      this.$emit("update-items", this.itemsFiltrados);
    },
  },

  watch: {
    citaPosterior: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.isJefeMedico) {
            this.canEditar = true;
          }
        }
      },
    },
    items: {
      deep: true,
      immediate: true,
      handler(newVal) {
        const ensureProcedimientoOption = (val) => {
          if (val == null) return null;
          const option = this.normalizeSelectOption(val);

          const exists = this.opcionesProcedimientos.some((opt) => {
            if (opt === option) return true;
            if (opt && option && opt.value != null && option.value != null) {
              return opt.value === option.value;
            }
            return false;
          });

          if (!exists) {
            this.opcionesProcedimientos = [...this.opcionesProcedimientos, option];
          }

          return option;
        };

        const nuevosItems = newVal.map((element, index) => {
          const prevItem = this.itemsFiltrados[index] || {};

          return {
            number:
              element.piezaDetails?.number ??
              element.number ??
              prevItem.number ??
              null,
            lado:
              element.piezaDetails?.zone ??
              element.lado ??
              prevItem.lado ??
              null,
            token:
              element.piezaDetails?.token ??
              element.token ??
              prevItem.token ??
              null,
            procedimiento_cie:
              ensureProcedimientoOption(
                element.procedimiento_cie ??
                  element.procedimientoCie ??
                  element.procedimiento_tarifario ??
                  element.procedimientoTarifario ??
                  element.procOdonto ??
                  element.procOdontoId ??
                  prevItem.procedimiento_cie ??
                  null
              ),
            doctor: element.doctor ?? prevItem.doctor ?? null,
            diagnostico_1:
              element.diagnostico_1 ?? prevItem.diagnostico_1 ?? null,
            diagnostico_2:
              element.diagnostico_2 ?? prevItem.diagnostico_2 ?? null,
            procedimiento:
              element.procedimiento ?? prevItem.procedimiento ?? null,
            fecha_realizacion:
              element.fecha_realizacion ?? prevItem.fecha_realizacion ?? null,
            encontrado: element.encontrado ?? prevItem.encontrado ?? false,
            realizado: element.realizado ?? prevItem.realizado ?? false,
            original: element.original ?? prevItem.original ?? false,
            movimiento: element.movimiento ?? prevItem.movimiento ?? null,
          };
        });

        if (
          JSON.stringify(nuevosItems) !== JSON.stringify(this.itemsFiltrados)
        ) {
          this.itemsFiltrados = nuevosItems;
          const availableTokens = new Set(
            nuevosItems.map((item) => item.token).filter(Boolean)
          );
          this.selectedTokens = this.selectedTokens.filter((token) =>
            availableTokens.has(token)
          );
          this.emitirDatos();
        }
      },
    },
  },
};
</script>
